import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

i18n
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // resources,
    fallbackLng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    // Language detection options
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },

    // Backend options
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },

    // Supported languages
    supportedLngs: ["en", "ar"],

    // Namespace
    ns: [
      "translation", // Keep as fallback during migration
      "modules", // Module system translations (nav, sidebar, breadcrumbs)
      "templates",
      "whatsapp-templates",
      "common",
      "account",
      "analytics",
      "billing",
      "broadcasts",
      "campaigns",
      "channels",
      "chatbots",
      "conversations",
      "customers",
      "integrations",
      "logs",
      "my-cave",
      "onboarding",
      "roles",
      "sender-registrations",
      "settings",
      "social-listening",
      "studio",
      "users",
      "workflows",
      "walkthrough",
      "nodes",
      "tickets",
      "whatsapp-onboarding",
      "email",
      "calendar",
      "console-ai",
    ],
    defaultNS: "translation",

    // Interpolation options
    interpolation: {
      escapeValue: false, // react already safes from xss
    },

    // Debug options (remove in production)
    debug: false,
  });

export default i18n;

// import i18n from "i18next";
// import { initReactI18next } from "react-i18next";
// import Backend from "i18next-http-backend";
// import LanguageDetector from "i18next-browser-languagedetector";
// import { getFallbackTranslations } from "./utils/preloadTranslations";

// // Get fallback resources
// const fallbackResources = getFallbackTranslations();

// // the translations
// // (tip move them in a JSON file and import them,
// // or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

// i18n
//   .use(Backend)
//   // detect user language
//   // learn more: https://github.com/i18next/i18next-browser-languageDetector
//   .use(LanguageDetector)
//   .use(initReactI18next) // passes i18n down to react-i18next
//   .init({
//     // Add fallback resources
//     resources: fallbackResources,
//     // resources,
//     fallbackLng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
//     // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
//     // if you're using a language detector, do not define the lng option

//     // Language detection options
//     detection: {
//       order: ['localStorage', 'navigator', 'htmlTag'],
//       caches: ['localStorage'],
//       lookupLocalStorage: 'i18nextLng',
//     },
//     //  (import.meta.env.BASE_URL || '') +
//     // Backend options
//     backend: {
//       // loadPath: '/locales/{{lng}}/{{ns}}.json',
//       loadPath: '/locales/{{lng}}/{{ns}}.json',

//       // // Additional options for production reliability
//       // crossDomain: false,
//       // allowMultiLoading: false,
//       // reloadInterval: false,
//       // // Retry configuration
//       // requestOptions: {
//       //   cache: 'default',
//       //   mode: 'same-origin'
//       // }
//     },

//     // Partials - allow partial loading for better error handling
//     partialBundledLanguages: true,

//     // Supported languages
//     supportedLngs: ['en', 'ar'],

//     // Namespace
//     ns: ['translation'],
//     defaultNS: 'translation',

//     // Interpolation options
//     interpolation: {
//       escapeValue: false, // react already safes from xss
//     },

//     // Debug options
//     debug: import.meta.env.DEV,

//     // React options
//     react: {
//       useSuspense: false, // Avoid suspense-related issues in production
//     },

//     // Error handling
//     saveMissing: false,
//     missingKeyHandler: (lng, ns, key) => {
//       if (import.meta.env.DEV) {
//         console.warn(`Missing translation key: ${key} for language: ${lng}`);
//       }
//     },

//     // Load options
//     load: 'languageOnly', // Only load language (e.g., 'en') not locale (e.g., 'en-US')
//     cleanCode: true,
//   })
//   .catch((error) => {
//     console.error('i18n initialization failed:', error);
//     // Initialize with fallback resources only
//     return i18n.init({
//       resources: fallbackResources,
//       fallbackLng: 'en',
//       lng: 'en',
//       debug: false,
//       interpolation: {
//         escapeValue: false,
//       },
//     });
//   });

// export default i18n;
